import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// Bundled so webpack ships the webfont next to the CSS. The old copy in
// public/ pointed at ../fonts/ files that were never deployed, so every
// icon rendered as an empty box.
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    theme: {
        dark: true,
        themes: {
            // Matches the palette in App.vue, so default-coloured inputs,
            // switches and focus rings use the brand teal instead of blue.
            dark: {
                primary: '#00ADB5',
                secondary: '#393E46',
                accent: '#00ADB5',
                error: '#fb4e4e',
            },
            light: {
                primary: '#175873',
                error: '#fb4e4e',
            },
        },
    },
});
